export default "__VITE_ASSET__CIDe3KMN__"